<template>
  <v-col cols="12" md="4" offset-md="4" align="center" class="mt-12" id="loginForm">
    <h1>{{ $vuetify.lang.t("$vuetify.view.signIn.oldLoginLink1") }}</h1>
    <p class="font-weight-regular">
      {{ $vuetify.lang.t("$vuetify.view.signIn.linkingLoginText") }}
    </p>
    <div style="display:flex;flex-direction:column;align-items:center;justify-content:center;">
      <login-with-google :clickFunc="login" />
      <login-with-apple :clickFunc="loginWithApple" />
      <!-- <v-btn
        class="google-btn mt-3"
        elevation="2"
        color="white"
        @click="login"
      >
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" xmlns:xlink="http://www.w3.org/1999/xlink" style="display: block;">
          <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"></path>
          <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"></path>
          <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"></path>
          <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"></path>
          <path fill="none" d="M0 0h48v48H0z"></path>
        </svg>
        <span>
        {{ $vuetify.lang.t("$vuetify.view.signIn.loginGoogleTitle") }}
        </span>
      </v-btn> -->
    </div>
  </v-col>
</template>

<script>
//import Vue from "vue";
const LoginWithGoogle = () => import("@/components/UI/LoginWithGoogle");
const LoginWithApple = () => import("@/components/UI/LoginWithApple");

export default {
  name: "LinkingComponent",
  components: { LoginWithGoogle, LoginWithApple },

  mounted() {
    // Load the reCAPTCHA script when the component is mounted
    const script = document.createElement("script");
    script.src = "https://www.google.com/recaptcha/api.js?render="+process.env.VUE_APP_RECAPTCHA_KEY;
    script.async = true;
    script.defer = true;
    document.head.appendChild(script);
  },


  data() {
    return {
      userPhoneNumber: null,
      updateValue: "",
      defaultCountry: "",
      countriesList: ["UA", "RU", "BY", "MD"],
      hasLoaderActive: false,
      hasErrorActive: false,
      loader: null,
      loading: false,
      verifyUrl: "",
      userData: {},
      option: "",
      users: {
        admin: "successfully_sent_to_a_phone",
        simple: "successfully_sent_to_phone",
      },
    };
  },
  watch: {
    userData() {
      let countryCode = this.userData.countryCode;
      let nationalNumber = this.userData.nationalNumber;
      switch (countryCode) {
        case "UA":
          if (nationalNumber) {
            if (Array.from(nationalNumber).length > 9) {
              this.hasErrorActive = true;
              this.userData.isValid = false;
            } else {
              this.hasErrorActive = false;
            }
          }
      }
    },
    loader() {
      const l = this.loader;
      this[l] = !this[l];

      setTimeout(() => (this[l] = false), 3000);
      this.loader = null;
    },
  },
  created() {
    this.defaultCountry = this.getPhoneCountryCode || "UA";
    this.verifyUrl = this.$route.meta.url;
    this.option = this.$route.meta.option;
    this.userPhoneNumber = this.$store.getters["user/getUserPhone"];
  },
  computed: {
    getPhoneCountryCode() {
      return this.$store.getters["user/getUserPhoneCountryCode"];
    },
    title() {
      return this.$vuetify.lang.t(this.$route.meta.title);
    },
    translations() {
      return {
        countrySelectorLabel: this.$vuetify.lang.t(
          "$vuetify.view.signIn.countrySelectorLabel"
        ),
        countrySelectorError: this.$vuetify.lang.t(
          "$vuetify.view.signIn.countrySelectorError"
        ),
        phoneNumberLabel: this.$vuetify.lang.t(
          "$vuetify.view.signIn.phoneNumberLabel"
        ),
        example: this.$vuetify.lang.t("$vuetify.view.signIn.example"),
      };
    },
  },
  methods: {
    loginWithApple() {
      this.$store.commit("user/SET_PROCESS_LINKING_LOGIN", true);

      let base = process.env.VUE_APP_API.replace(/\/+$/, '');
      window.location.href = `${base}/api/auth/login/apple`;
    },
    login() {
      this.$store.commit("user/SET_PROCESS_LINKING_LOGIN", true);

      let base = process.env.VUE_APP_API.replace(/\/+$/, '');
      window.location.href = `${base}/api/auth/login/google`;
      /* this.$store.commit("user/SET_USER_PHONE", {
        phone: "",
        code: "",
      });
      window.google.accounts.oauth2.initTokenClient({
        client_id: process.env.VUE_APP_GOOGLE_OAUTH2_CLIENT_ID,
        scope: "openid email profile",
        callback: (resp) => {
          let payload = {
            provider: 'google',
            token: resp.access_token,
          };
          this.loader = "loading";
          this.$store
            .dispatch('user/linkLogin', JSON.stringify(payload))
            // eslint-disable-next-line no-unused-vars
            .then((response) => {
              if (response.status === 200) {
                let authParam = this.$store.getters["user/getAuthParam"];
                let url = '/dashboard/main';
                let redirect = this.$route.query.redirect || url;
                if(authParam.userRole == "admin" || authParam.userRole == "redactor") {
                  redirect = '/dashboard/blog';
                }
                this.$router.push(redirect);
                Vue.swal({
                  target: document.getElementById("main"),
                  text: response.data.message,
                  icon: "success",
                  timer: 4000,
                  toast: true,
                  position: "top-right",
                  showConfirmButton: false,
                });
                this.$store.commit("user/SET_ADMIN_TRIGGER", false);
              }
            })
            .catch((error) => {
              if (error instanceof TypeError) {
                Vue.swal({
                  target: document.getElementById("main"),
                  text: this.$vuetify.lang.t(
                    "$vuetify.view.restore.error"
                  ),
                  icon: "error",
                  timer: 4000,
                  toast: true,
                  position: "top-right",
                  showConfirmButton: false,
                });
              }
              
              if (error.error === "user_exists") {
                Vue.swal({
                  target: document.getElementById("main"),
                  text: this.$vuetify.lang.t(
                    "$vuetify.view.restore.user_exists"
                  ),
                  icon: "error",
                  timer: 4000,
                  toast: true,
                  position: "top-right",
                  showConfirmButton: false,
                });
              }
            })
            .finally(() => {
              this.loader = false;
            });
        }
      }).requestAccessToken(); */
    },
    onSubmit() {
      this.$refs.submitButton.$el.click();
    },
    updatedData(data) {
      this.userData = data;
    },
    setDispatchType(option) {
      switch (option) {
        case "auth":
          return "user/sendCode";
        case "psychReg":
          return "user/sendUserRegCode";
        case "patientReg":
          return "user/sendUserRegCode";
      }
    },
    async sendPhoneNumber() {
      if (this.userData.isValid) {
        this.loader = "loading";

        this.$store.commit("user/SET_LOGIN_PROVIDER", {
          provider: null,
          provider_id: null,
        });

        const recaptchaKey = process.env.VUE_APP_RECAPTCHA_KEY;
        const recaptchaToken = recaptchaKey && window.grecaptcha
          ? await new Promise(resolve => {
              window.grecaptcha.execute(recaptchaKey, { action: 'submit' }).then(token => resolve(token));
            })
          : null;

        let payload = {
          phone: this.userData.formattedNumber,
          recaptchaToken: recaptchaToken,
        };
        await this.$store
          .dispatch(this.setDispatchType(this.option), JSON.stringify(payload))
          // eslint-disable-next-line no-unused-vars
          .then((response) => {
            this.$store.commit(
              "user/SET_ADMIN_TRIGGER",
              response.data.code === "successfully_sent_to_a_phone"
            );
            this.$router.push({
              path: this.verifyUrl,
              query: { redirect: this.$route.query.redirect }
            });
          })
          .catch((error) => {
            if (error instanceof TypeError) {
              this.$store.commit("user/SET_USER_PHONE", {
                phone: this.userData.formattedNumber,
                code: this.userData.countryCode,
              });
              this.$router.replace("/auth");
            }
            if (error.code === "user_not_exists")
              this.$router.replace("/registration");
          })
          .finally(() => {
            this.loader = false;
          });
        this.$store.commit("user/SET_USER_PHONE", {
          phone: this.userData.formattedNumber,
          code: this.userData.countryCode,
        });
      }
    },
  },
};
</script>

<style scoped>
.google-btn {
  text-transform: none;
  font-weight: normal;
  max-width: 100%;
  display: flex;
  white-space: normal;
  height: 60px !important;
}
.google-btn svg {
  height: 30px;
  margin-right: 8px;
}
.old-login-link a {
  text-decoration: none;
}
</style>
